import * as actionTypes from '../actions/ActionTypes';
import Config from '../../utils/Configuration'

const updateCurrentScreenName = (state, payload) => {
    const updatedState = {
        ...state,
        currentScreen: payload
    };
    sessionStorage.setItem(Config.sliceKey.screenName, JSON.stringify(updatedState));
    return updatedState;
};
const updatePreviousScreenName = (state, payload) => {
    const updatedState = {
        ...state,
        previousScreen: payload
    };
    sessionStorage.setItem(Config.sliceKey.screenName, JSON.stringify(updatedState));
    return updatedState;
};
const reducer = (state = '', action) => {
    const {payload} = action;
    switch (action.type) {
        case actionTypes.UPDATE_SCREEN_NAME: {
            return updateCurrentScreenName(state, payload);
        }
        case actionTypes.UPDATE_PREVIOUS_SCREEN_NAME: {
            return updatePreviousScreenName(state, payload);
        }
        default:
            return state;
    }
};

export default reducer;
